
import { Options, Vue } from 'vue-class-component';
import StartRating from '../../common/StarRating.vue'
import ProductCarousel from './ProductCarousel.vue'
@Options({
  components: {
    StartRating,
    ProductCarousel
  },
  props: {
    restorant: {
      type: Object,
      required: true
    }
  }
})
export default class Restorants extends Vue {
  restorant!: any



}
